import 'react';
import { deprecatedComponent } from '../core/deprecated-component.js';
import 'tiny-warning';
import { BasicPreloader as BasicPreloader$1 } from './basic-preloader.component.js';
import { Preloader as Preloader$1 } from './preloader.component.js';
export { propTypes } from './preloader.component.js';
export { PreloaderInner } from './preloader-inner.component.js';

/* PLOP_COMPONENT_EXPORT_IN_INDEX */
const Preloader = deprecatedComponent({
  displayName: 'Preloader',
  root: Preloader$1,
  description: 'Use Spinner component instead'
});
const BasicPreloader = deprecatedComponent({
  displayName: 'BasicPreloader',
  root: BasicPreloader$1,
  description: 'Use Spinner component instead'
});
export { BasicPreloader, Preloader };